import styled, { keyframes } from 'styled-components';
import RoyalIcon from 'components/svg/Royal';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import React, { useContext, useEffect } from 'react';

const animateRotate = keyframes`
  100% { transform: rotate(360deg); }
`;

const animateFade = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

const LoaderSpinner = styled.svg`
  animation: 1s linear infinite ${animateRotate};
  height: 7.5rem;
  left: 50%;
  margin: -3.75rem 0 0 -3.75rem;
  position: absolute;
  top: 50%;
  width: 7.5rem;
  z-index: 30;

  position: absolute;
  width: 120px;
  height: 120px;
  margin-left: -60px;
  margin-top: -60px;
  circle {
    stroke-dasharray: 100, 150;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    stroke: #005edc;
    z-index: 30;
  }
`;

const LoaderIcon = styled.div`
  animation: 1.8s infinite ${animateFade};
  opacity: 1;
  z-index: 30;
  svg {
    fill: #005edc;
  }
  position: absolute;
  display: flex;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  margin-top: -25px;
  margin-left: -25px;
`;

const LoaderBackground = styled.div`
  width: 100vw;
  height: 100vh;
  z-index: 10;
  background: white;
  opacity: 0.9;
  top: 0;
  left: 0;
  position: fixed;
`;

const Loader = () => {
  const { showLoading } = useContext(CruiseSearchContext);

  useEffect(() => {
    document
      ?.getElementsByTagName('html')[0]
      ?.setAttribute('style', showLoading ? 'overflow: hidden;' : '');
  }, [showLoading]);

  return (
    showLoading && (
      <LoaderBackground>
        <div>
          <LoaderSpinner
            className="loading-indicator__spinner"
            viewBox="0 0 50 50"
          >
            <circle
              className="loading-indicator__spinner-path"
              cx="25"
              cy="25"
              fill="none"
              r="20"
              strokeWidth="1"
            ></circle>
          </LoaderSpinner>
          <LoaderIcon>
            <RoyalIcon />
          </LoaderIcon>
        </div>
      </LoaderBackground>
    )
  );
};

export default Loader;
